import App from './App'

const Body = () => {

    
    return (
        <div className="body">
            <h1><u> REACT ANIMATED DIGITS COMPONENT</u></h1>
            <App/>
        </div>
    )
}

export default Body
